import { Component, ViewChild } from '@angular/core';
import { ModalHostDirective } from '../../directives/modal-host.deirective';
import { AppModalService } from '../../services/app-modal.service';
import { ModalWidth } from '../../types/modal/modal-base';
import { ModalButton } from '../../types/modal/modal-button';

@Component({
    selector: 'app-modal',
    templateUrl: './modal-base.component.html',
    styleUrls: ['./modal-base.component.scss']
})
export class ModalBaseComponent {

    @ViewChild(ModalHostDirective) appModalHost: ModalHostDirective;

    title: string;
    width: number = ModalWidth.lg;
    isShow: boolean = false;
    buttons: ModalButton[];

    constructor(
        public modalService: AppModalService,
    ) {
        this.modalService.setBaseComponent(this);
    }

    public open() {
        this.isShow = true;
    }

    public close() {
        this.isShow = false;
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/modal-base/modal-base.component.ts